/**
 * A tiny channel from the API client to the TenantProvider. The client
 * calls `emitTenantSignal` when any response says the workspace is paused
 * (402 `workspace_paused`) or the host is unknown (404 `tenant_not_found`);
 * the provider listens and switches screen. Kept dependency free so the
 * client can import it without a cycle.
 */

export type TenantSignal = "paused" | "not_found";

type Listener = (signal: TenantSignal) => void;

const listeners = new Set<Listener>();

export function emitTenantSignal(signal: TenantSignal): void {
  for (const l of listeners) l(signal);
}

export function onTenantSignal(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
